export default __webpack_public_path__ + "static/3-1674396a7b56568aa035e41042fa2acf.jpg";